export const CONTAINER_ANIMATION = {
  unMounted: { opacity: 0 },
  mounted: {
    opacity: 1,
    transition: {
      duration: 0.8,
    },
  },
};
